<template><div>
	<v-card>
	<v-card-title>
		<b>Users and Projects</b>
		<v-btn small class="ml-3" @click="authorize_new_user" color="primary">Authorize New User</v-btn>
		<v-spacer></v-spacer>
		<v-text-field v-model="search" append-icon="fa fa-search" label="Search" single-line hide-details></v-text-field>
	</v-card-title>
	<v-data-table
		:headers="headers"
		:items="projects"
		:items-per-page="-1"
		:search="search"
		:must-sort="true"
		:options="{'sortBy':['updated_at_val'],'sortDesc':[true]}"
	>
	<template v-slot:item="{ item }"><tr :class="item.row_class">
		<td>
			<v-tooltip bottom><template v-slot:activator="{on}"><v-icon v-on="on" v-if="item.user_authorized" class="mr-1" small color="green" @click="deauthorize_user(item.user.email)">fas fa-user-check</v-icon></template><span>User is currently authorized; click to deauthorize.</span></v-tooltip>
			<v-tooltip bottom><template v-slot:activator="{on}"><v-icon v-on="on" v-if="!item.user_authorized" class="mr-1" small color="yellow darken-3" @click="reauthorize_user(item.user.email)">fas fa-user-times</v-icon></template><span>User is currently deauthorized; click to reauthorize.</span></v-tooltip>
			<span v-html="item.user_display"></span>
		</td>
		<td v-html="item.created_at_display"></td>
		<td v-html="item.updated_at_display"></td>
		<td v-html="item.project_name_display"></td>
		<td v-html="item.case_framework_display"></td>
		<td v-html="item.status_summary_display"></td>
	</tr></template>
	</v-data-table>
</v-card>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() { return {
		search: '',
		users: [],
		projects: [],
		headers: [
			{ text: 'User', value: 'user_val', sortable: true, align: 'left' },
			{ text: 'Created At', value: 'created_at_val', sortable: true, align: 'center' },
			{ text: 'Updated At', value: 'updated_at_val', sortable: true, align: 'center' },
			{ text: 'Project Name', value: 'project_name_display', sortable: true, align: 'left' },
			{ text: 'CASE Framework', value: 'case_framework_val', sortable: true, align: 'left' },
			{ text: 'Project Stats', value: 'user_val', sortable: false, align: 'left' },
        ],
	}},
	computed: {
		...mapState(['user_info']),
	},
	created() {

	},
	mounted() {
		this.get_admin_data()
	},
	methods: {
		get_admin_data() {
			let o = {
				user_id: this.user_info.user_id,
			}
			U.loading_start()
			U.ajax('admin_get_all_projects', o, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					this.$alert(result.status)
					return
				}
				this.users = result.users
				let rows = []
				// go through all users
				for (let user of this.users) {
					// determine initial value for row_class based on user authorization
					let initial_row_class = (user.cgrt_enabled == 'true') ? '' : 'k-admin-table__user_deauthorized'

					// if user has no projects, add an empty row
					if (empty(user.projects) || user.projects.length == 0) {
						rows.push({
							row_class: initial_row_class,
							user: user,
							user_display: (user.displayname == '') ? sr('$1 (never signed in)', user.email) : sr('$1 ($2)', user.name, user.email),
							user_val: user.email,
							user_authorized: user.cgrt_enabled == 'true',
							created_at_val: 0,
							created_at_display: '',
							updated_at_val: 0,
							updated_at_display: '',
							project_name_display: '',
							case_framework_display: '',
							case_framework_val: '',
							status_summary_display: '',
						})

					// else one row per project
					} else {
						for (let project of user.projects) {
							project = new CGRT_Project(project)

							rows.push({
								// row gets project_deleted class if deleted, otherwise class based on whether or not the user is enabled
								row_class: project.deleted ? 'k-admin-table__project_deleted' : initial_row_class,

								user: user,
								user_val: sr('$1 $2', user.name, user.email),
								user_display: sr('$1 ($2)', user.name, user.email),
								user_authorized: user.cgrt_enabled == 'true',

								created_at_val: project.created_at,
								created_at_display: date.format(new Date(project.created_at*1000), 'D MMM, YYYY'),
								updated_at_val: project.updated_at,
								updated_at_display: date.format(new Date(project.updated_at*1000), 'D MMM, YYYY'),

								project_name_display: project.project_name,

								case_framework_display: sr('<a href="https://casenetwork.imsglobal.org/uri/$1" target="$1">$2</a>', project.case_framework_guid, project.case_framework_title),
								case_framework_val: sr('$1 $2', project.case_framework_guid, project.case_framework_title),

								status_summary_display: '<nobr>' + ((project.status_summary.db_row_count == 0) ? 'Not opened' : sr('$1 rows; $2% matched', project.status_summary.db_row_count, Math.round(project.status_summary.matched / project.status_summary.db_row_count * 100))) + '</nobr>',
							})
						}
					}
				}

				// if we don't do this the user icon doesn't seem to update properly
				this.projects = []
				this.$nextTick(()=>{ this.projects = rows })
			})
		},

		authorize_new_user() {
			this.$prompt({
				title: 'Authorize New User',
				text: 'Enter the Google-enabled email address for the user you would like to authorize to use the tool:',
				acceptText: 'Authorize User',
			}).then(email => {
				if (empty(email)) return

				let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			    if (!re.test(String(email).toLowerCase())) {
					this.$alert('Please enter a valid email address.')
					return
				}

				let o = {
					user_id: this.user_info.user_id,
					email_to_authorize: email
				}
				U.loading_start()
				U.ajax('admin_authorize_user', o, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						this.$alert(result.status)
						return
					}
					this.get_admin_data()
				})
			}).catch(n=>{}).finally(f=>{});
		},

		reauthorize_user(email) {
			this.$confirm({
			    title: 'Are you sure?',
			    text: 'Are you sure you want to re-authorize this user, allowing them to use the tool again?',
			    acceptText: 'Reauthorize User',
				acceptColor: 'green',
			}).then(y => {
				let o = {
					user_id: this.user_info.user_id,
					email_to_authorize: email
				}
				U.loading_start()
				U.ajax('admin_authorize_user', o, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						this.$alert(result.status)
						return
					}
					this.get_admin_data()
				})
			}).catch(n=>{}).finally(f=>{});
		},

		deauthorize_user(email) {
			this.$confirm({
			    title: 'Are you sure?',
			    text: 'Are you sure you want to de-authorize this user, preventing them from using the tool in the future? (You can always re-authorize the user later; any projects the user has previously created will not be lost.)',
			    acceptText: 'Deauthorize User',
				acceptColor: 'red',
			}).then(y => {
				let o = {
					user_id: this.user_info.user_id,
					email_to_deauthorize: email
				}
				U.loading_start()
				U.ajax('admin_deauthorize_user', o, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						this.$alert(result.status)
						return
					}
					this.get_admin_data()
				})
			}).catch(n=>{}).finally(f=>{});
		},
	}
}
</script>

<style lang="scss">
.k-admin-table__project_deleted {
	td {
		background-color:#FFCDD2;
	}
}

.k-admin-table__user_deauthorized {
	td {
		background-color:#FFF9C4;
	}
}
</style>
